import React, { useState } from 'react';
import HomeworkTracker from './HomeworkTracker';
import QuizSectionTestPage from './components/quiz/test/QuizSectionTestPage';

function App() {
  // 開発環境でのテスト用フラグ
  const [showTestPage, setShowTestPage] = useState(false);
  
  // 開発環境のみテストページ切り替えボタンを表示
  if (process.env.NODE_ENV === 'development') {
    return (
      <div className="App">
        {/* テストモード切り替えボタン */}
        <div className="fixed top-4 right-4 z-50">
          <button
            onClick={() => setShowTestPage(!showTestPage)}
            className={`px-4 py-2 rounded-lg text-sm font-medium shadow-lg transition-colors ${
              showTestPage 
                ? 'bg-red-100 text-red-700 border border-red-300 hover:bg-red-200'
                : 'bg-green-100 text-green-700 border border-green-300 hover:bg-green-200'
            }`}
          >
            {showTestPage ? '通常モードに戻る' : 'ローディングテスト'}
          </button>
        </div>
        
        {showTestPage ? <QuizSectionTestPage /> : <HomeworkTracker />}
      </div>
    );
  }

  // 本番環境では通常のアプリを表示
  return (
    <div className="App">
      <HomeworkTracker />
    </div>
  );
}

export default App;

